import { motion } from 'framer-motion';
import { categoryColors } from '../data/portfolioData';

interface SkillCardProps {
  name: string;
  category: string;
  index: number;
}

export default function SkillCard({ name, category, index }: SkillCardProps) {
  const color = categoryColors[category] || '#00f0ff';

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: index * 0.03, duration: 0.3 }}
      className="relative group"
    >
      <div
        className="px-3 py-2 rounded-lg border text-sm font-medium
                   backdrop-blur-md transition-all duration-300
                   hover:scale-105 cursor-default"
        style={{
          background: `linear-gradient(135deg, ${color}10, ${color}05)`,
          borderColor: `${color}30`,
          color: color,
          boxShadow: `0 0 0px ${color}00`,
        }}
        onMouseEnter={(e) => {
          (e.target as HTMLElement).style.boxShadow = `0 0 15px ${color}30`;
          (e.target as HTMLElement).style.borderColor = `${color}60`;
        }}
        onMouseLeave={(e) => {
          (e.target as HTMLElement).style.boxShadow = `0 0 0px ${color}00`;
          (e.target as HTMLElement).style.borderColor = `${color}30`;
        }}
      >
        {name}
        <span
          className="block text-[10px] mt-0.5 opacity-50 font-normal"
        >
          {category}
        </span>
      </div>
    </motion.div>
  );
}
